import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { REALTORS_ACTION_TYPE } from '../actions';

const initialState = {};

const reducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case REALTORS_ACTION_TYPE.GET_REALTORS:
        return { ...state, ...payload };
      case REALTORS_ACTION_TYPE.EDIT_REALTOR:
        draft[payload.id] = { ...state[payload.id], ...payload };
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default reducer;
